import React, { createContext, useContext, useState, useCallback } from 'react';

interface ZoomContextType {
    zoomLevel: number;
    increaseZoom: () => void;
    decreaseZoom: () => void;
    resetZoom: () => void;
}

const ZoomContext = createContext<ZoomContextType | null>(null);

export const useZoom = () => {
    const context = useContext(ZoomContext);
    if (!context) {
        throw new Error('useZoom must be used within a ZoomProvider');
    }
    return context;
};

interface ZoomProviderProps {
    children: React.ReactNode;
}

export const ZoomProvider: React.FC<ZoomProviderProps> = ({ children }) => {
    const [zoomLevel, setZoomLevel] = useState(1);

    const increaseZoom = useCallback(() => {
        setZoomLevel(prev => Math.min(prev + 0.1, 2.0)); // Max 200%
    }, []);

    const decreaseZoom = useCallback(() => {
        setZoomLevel(prev => Math.max(prev - 0.1, 0.5)); // Min 50%
    }, []);

    const resetZoom = useCallback(() => {
        setZoomLevel(1);
    }, []);

    return (
        <ZoomContext.Provider value={{ zoomLevel, increaseZoom, decreaseZoom, resetZoom }}>
            {children}
        </ZoomContext.Provider>
    );
}; 